import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content-header\"><div class=\"container-fluid\"><div class=\"row mb-2\"><div class=\"col-sm-6\"><h1>Tipos de produtos</h1></div><div class=\"col-sm-6\"><ol class=\"breadcrumb float-sm-right\"><li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li><li class=\"breadcrumb-item active\">Tipos de produtos</li></ol></div></div></div></section>", 1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body row" }
const _hoisted_11 = { class: "form-group col-12 col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Descrição:    ", -1)
const _hoisted_13 = { class: "form-group col-12 col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "enabled" }, "Situação:    ", -1)
const _hoisted_15 = { class: "card-footer text-center" }
const _hoisted_16 = { class: "btn-group" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, "Tipos de produtos | " + _toDisplayString(_ctx.id), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: "Voltar"
              }, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.row.description), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
              'bg-success': _ctx.row.enabled,
              'bg-danger': !_ctx.row.enabled
            }])
              }, _toDisplayString(_ctx.row.enabled ? 'Ativo' : 'Inativo'), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-info",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.goBack()))
              }, "Voltar"),
              (_ctx.hasPermission('edit'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    id: "editarButton",
                    class: "btn btn-warning",
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.edit()))
                  }, "Editar"))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}